import React from 'react';
import BackendIcon from '../svg/backend.svg';

const IconBackend = () => <img src={BackendIcon} alt="Backend Icon" width={64} height={64} />;

export default IconBackend;
